import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.scss";
import { dataToJS, pathToJS, firebaseConnect } from "react-redux-firebase";
import BlankPage from "../blank/";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";
class Admin extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    // Call with info
  }

  createGroup() {
    // this.props.firebase.push("/groups", { name: "Summer 2017" });
  }

  componentWillReceiveProps(props) {}
  render() {
    return (
      <div className="challenge-creator">
        <div className="toolbar">
          <h1>Admin</h1>
        </div>
        <div className="content">
          <div className="page">
            <div className="max-width" />

            <button onClick={this.createGroup.bind(this)}>NEw User</button>
            <ul>
              {this.props.groups &&
                Object.keys(this.props.groups).map((key, id) => (
                  <Link key={key} id={id} to={`/admin/group/${key}`}>
                    <li>{this.props.groups[key].name}</li>
                  </Link>
                ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  // Map state to props
  ({ firebase }) => ({
    groups: dataToJS(firebase, "groups"),
    logs: dataToJS(firebase, "logs"),
    auth: pathToJS(firebase, "auth"),
    profile: pathToJS(firebase, "profile")
  })
)(firebaseConnect(["/groups"])(Admin));



// WEBPACK FOOTER //
// ./src/routes/admin/index.js